/**
 * The room-charge provider's slug — FROZEN, it is the provider's former
 * company name. It is persisted in `orders.settled_by` (mirrored by the
 * backend's `HotelSyncProvider::SLUG`) and it is also the tenant
 * feature-gate key in `store.integrations` (the integrations-table row name
 * served by `/load`): the same string deliberately identifies the provider
 * everywhere.
 */
export const ROOM_CHARGE_PROVIDER = 'ota_sync';
//# sourceMappingURL=constants.js.map